module.exports = __webpack_public_path__ + "img/UC_Santa_Barbara_Wordmark_Black_RGB.911ec77d.png";